<div class="gestion-container">
  <header>
    <h3 class="mb-2"><strong> Configuración del carrusel </strong></h3>    
    <div class="d-flex justify-content-between align-items-end w-100 mt-4">
      <ul class="nav nav-tabs border-bottom-0 m-0" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link"
            [ngClass]="{'active': !mostrarTabla && bannerType === 1}"
            id="home-tab" 
            data-bs-toggle="tab" 
            data-bs-target="#visita-efectiva" 
            type="button"
            role="tab" 
            aria-controls="home" 
            aria-selected="true"
            (click)="onChangeTable(1)"
          >
            Banner 1
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            [ngClass]="{'active': !mostrarTabla && bannerType === 2}"
            id="profile-tab" 
            data-bs-toggle="tab"
            type="button"
            role="tab" 
            aria-controls="profile" 
            aria-selected="false"
            (click)="onChangeTable(2)"
          >
            Banner 2
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            [ngClass]="{'active': !mostrarTabla && bannerType === 3}"
            id="profile-tab" 
            data-bs-toggle="tab"
            type="button"
            role="tab" 
            aria-controls="profile" 
            aria-selected="false"
            (click)="onChangeTable(3)"
          >
            Banner 3
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link" 
            [ngClass]="{'active': !mostrarTabla && bannerType === 4}"
            id="profile-tab" 
            data-bs-toggle="tab"
            type="button"
            role="tab" 
            aria-controls="profile" 
            aria-selected="false"
            (click)="onChangeTable(4)"
          >
            Banner SAC
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link"
            [ngClass]="{'active': !mostrarTabla && bannerType === 5}" 
            id="profile-tab" 
            data-bs-toggle="tab"
            type="button"
            role="tab" 
            aria-controls="profile" 
            aria-selected="false"
            (click)="onChangeTable(5)"
          >
            Banner Funciones
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link"
            [ngClass]="{'active': vistaActual === 'copiloto'}" 
            id="copiloto-tab" 
            type="button"
            role="tab" 
            (click)="onChangeTable(6)"
          >
            Banner Mi Copiloto
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link"
            [ngClass]="{'active': mostrarTabla && vistaActual === 'ordenar'}" 
            id="ordenar-tab" 
            type="button"
            role="tab" 
            (click)="onChangeView('ordenar')"
          >
            Orden Banners
          </button>
        </li>
      </ul>
      
      <div class="mb-2" *ngIf="mostrarTabla && vistaActual === 'ordenar'"> 
        <button 
          type="button" 
          class="text-white btn-order-banners" 
          [disabled]="!huboCambios" 
          (click)="onSubmitOrderBanners()"
        >
          <strong>Guardar</strong>
        </button>
      </div>
    </div>
    
    <!-- Línea divisoria -->
    <div style="border-bottom: 1px solid #dee2e6; width: 100%; margin-top: -1px;"></div>
  </header>
  
  <div *ngIf="!mostrarTabla || vistaActual === 'copiloto'">

    <!-- BUSCADOR -->
    <div class="row col-12 px-0 mx-0">
      <div class="card w-100">
        <div class="card-body">
          <mat-icon class="icon-c-folder icon-search" aria-hidden="false">search</mat-icon>
          <div class="row mt-2 mx-0 align-items-center">
            <div class="col-8 pl-0 inp-search">
              <input 
                matInput 
                (keyup)="applyFilter($event)" 
                class="form-control form-create" 
                placeholder="Buscar" 
                style="padding-left: 42px;"
                #input
              >
            </div>
            <div class="col-4 pr-0 btn-nuevo">
              <div class="d-flex justify-content-end">
                <button type="button" class="text-white btn-send" (click)="changeView('nuevo-banner', 0);">
                  <strong>Nuevo</strong>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- TABLA PRINCIPAL -->
    <div class="row col-12">
      <div class="col-12" *ngIf='dataSource'>
        
        <table class="example-table mat-elevation-z8" mat-table recycleRows [dataSource]="dataSource">
          <!-- Nombre Column -->
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef> Nombre </th>
            <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
          </ng-container>

          <!-- Fecha creacion Column -->  
          <ng-container matColumnDef="fechaCreacion">
            <th mat-header-cell *matHeaderCellDef> Fecha de creación </th>
            <td mat-cell *matCellDef="let element"> {{ element.fechaCreacion }} </td>
          </ng-container>

          <!-- Fecha inicio Column -->
          <ng-container matColumnDef="fechaInicio">
            <th mat-header-cell *matHeaderCellDef> Fecha inicio </th>
            <td mat-cell *matCellDef="let element"> {{ element.fechaInicio | slice: 0 : 19}} </td>
          </ng-container>

          <!-- Fecha fin Column -->
          <ng-container matColumnDef="fechafin">
            <th mat-header-cell *matHeaderCellDef> Fecha fin </th>
            <td mat-cell *matCellDef="let element"> {{ element.fechaFin | slice: 0 : 19}} </td>
          </ng-container>

          <!-- Estatus Column -->
          <ng-container matColumnDef="estatus">
            <th mat-header-cell *matHeaderCellDef> Estatus </th>
            <td mat-cell *matCellDef="let element"> 
              <div class="d-flex status-column">
                <mat-icon class="material-icons activo" *ngIf="element.estatus == 1"> check_circle_outline </mat-icon>
                <mat-icon class="material-icons desactivado" *ngIf="element.estatus == 2"> block </mat-icon>
                <mat-icon class="material-icons programado" *ngIf="element.estatus == 3"> alarm_on </mat-icon>
                
                <small class="status-class" *ngIf="element.estatus == 1"> Activo </small>
                <small class="status-class" *ngIf="element.estatus == 2"> Desactivado </small>
                <small class="status-class" *ngIf="element.estatus == 3"> Programado </small>
              </div>
            </td>
          </ng-container>

          <!-- Editar Column -->
          <ng-container matColumnDef="editar">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;"> </th>
            <td mat-cell *matCellDef="let element"> 
              <button type="button" class="btn btn-dimgray mt-1 icon-padding" (click)="rowValue(element); changeView('nuevo-banner', element)">
                <mat-icon class="icon-c-folder icon-display" svgIcon="icon-edit" aria-hidden="false"></mat-icon>
              </button>  
            </td>
          </ng-container>

          <!-- Reporte Column -->
          <ng-container matColumnDef="reporte">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;"> </th>
            <td mat-cell *matCellDef="let element" style="text-align: center;"> 
              <button type="button" class="btn btn-dimgray mt-1" (click)="onDownloadReport(element);">
                <mat-icon class="icon-c-folder" aria-hidden="false"> save_alt </mat-icon>
              </button>  
            </td>
          </ng-container>

          <!-- Eliminar Column -->
          <ng-container matColumnDef="eliminar">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;"> </th>
            <td mat-cell *matCellDef="let element" style="text-align: center;"> 
              <button 
                type="button" 
                class="btn btn-dimgray mt-1" 
                (click)="rowValue(element); openModal(deleteMessage)" 
              >
                <mat-icon class="icon-c-folder" aria-hidden="false"> delete_outline </mat-icon>
              </button>  
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="col-12 card" *ngIf='dataSource.data.length === 0'>
          <div class="card-empty text-center">
            <p style="margin-top: 120px;"> Aun no se han configurado banners </p>
          </div>
        </div>
        <div class="col-12 card" *ngIf='dataSource.filteredData.length === 0 && dataSource.data.length != 0'>
          <div class="card-empty text-center">
            <p style="margin-top: 120px;"> No hay resultados para tu búsqueda </p>
          </div>
        </div>
        <div class='w-100 d-flex justify-content-end' style="margin-left: 20px;" *ngIf='dataSource'>
          <mat-paginator 
            #paginator
            class="paginador"
            [length]='records' 
            [showFirstLastButtons]='false' 
            [pageSize]="8" 
            [hidePageSize]='true' 
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <!-- SECCIÓN ORDEN BANNERS -->
  <div *ngIf="mostrarTabla && vistaActual === 'ordenar'" class="order-banner-box">
    <app-order-banners (ordenCambiado)="onOrdenBannersChange($event)"></app-order-banners>
  </div>

  <!-- MODAL ELMINAR MENSAJE -->
  <ng-template #deleteMessage let-modal>
    <div class="card-alert">
      <!-- Imagen -->
      <div class="col-md-6 offset-md-3 mt-4 text-center confirmation">
        <img class="warning-image" src="https://s3.amazonaws.com/dev.structure.files/assets/advertencia.png" />
        <h3 class="mt-2">Advertencia</h3>
      </div>
      <div class="col-md-8 offset-md-2">
        <p class="text-center alert-body mt-3">
          ¿Estás seguro que quieres eliminar?, esta acción no se puede revertir.
        </p>
      </div>
      <!-- FOOTER -->
      <div class="pt-2 col-12 mt-3 mb-4 footer-modal">
        <button type="button" class="btn btn-cancel radius-btn" (click)="modal.close('Close click');">
          <strong style="padding-right: 5px;">Cancelar</strong>
        </button>
        <button type="button" class="btn btn-acept-modal radius-btn" (click)="deleteItem(onDeleteSuccess); modal.close('Close click');">
          <strong style="padding-right: 5px;">Eliminar</strong>
        </button>
      </div>
    </div>
  </ng-template>

  <!-- MODAL ELIMINAR BANNER ÉXITO -->
  <ng-template #onDeleteSuccess let-modal>
    <div class="card-alert">
      <!-- Imagen -->
      <div class="col-md-6 offset-3 mt-4 text-center confirmation">
        <img class="warning-image" src="https://s3.amazonaws.com/dev.structure.files/assets/creado.png" />
        <h2 class="mt-3"> Éxito </h2>
      </div>
      <div class="col-md-8 offset-md-2">
        <p class="text-center alert-body mt-1">
          Se ha eliminado el registro
        </p>
      </div>
      <div class="modal-footer mt-3">
        <div class="col-8">
          <button type="button" class="btn form-button" (click)="modal.close('Close click')">Entendido</button>
        </div>
      </div>
    </div>
  </ng-template>

</div>
   